import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';

import '@fortawesome/fontawesome-free/css/all.css';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../src/css/dashboard.css';
import 'chart.js/dist/Chart.css';

import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'jquery.easing/jquery.easing';
import 'datatables.net/js/jquery.dataTables.js';
import 'datatables.net-bs4/js/dataTables.bootstrap4.js';
import '../src/js/dashboard.js';
import '../src/js/dataTables.js';
import 'chart.js/dist/Chart.min.js';

import App from './App';

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
